export default __webpack_public_path__ + "static/media/banner_property.dcd07bd5.png";